module.exports = __webpack_public_path__ + "static/media/th_bg_desktop.fe49f23d.jpg";